export default "__VITE_ASSET__C5FAFS$8__"